// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1N5Xh","productName":"Table_productName__1HeGI"};